// extracted by mini-css-extract-plugin
export var lg = "1440";
export var m = "1024";
export var md = "768";
export var sm = "576";
export var xl = "1200";